<template>
  <div>
    <div class="titles">
        <div class="title titleLeft">主开通人</div>
        <div class="titleRight pointer" v-if="hostData.length > 0" @click="hostPeople">修改</div>
    </div>
    <div>
        <Row :gutter="30">
          <Col :md="12" :xl="8" :xxl="6" class="w-20" v-if="hostData.length < 1">
            <div class="addPro pro pointer" @click="hostPeople">
              <i class="icon iconfont icon-jia3"></i>
              <span>添加联系人</span>
            </div>
          </Col>
          <Col
            :md="12"
            :xl="8"
            :xxl="6"
             v-if="hostData.length > 0"
            class="w-20"
          >
            <div class="pro proText">
                <p>姓名：{{ hostData[0].name }}</p>
                  <p>身份证号：{{ hostData[0].iDNumber }}</p>
                  <p>手机：{{ hostData[0].phoneNumber }}</p>
                  <p>邮箱：{{ hostData[0].email }}</p>
            </div>
          </Col>
        </Row>
    </div>
    <div class="titles">
        <div class="titleNo titleLeft">次开通人</div>
        <div class="titleRight pointer" @click="secondPeople">添加联系人</div>
    </div>
    <div class="p30">
        <el-table
    :data="secondData"
    border
    style="width: 100%">
    <el-table-column
      prop="name"
      label="姓名">
    </el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="手机号">
      </el-table-column>
        <el-table-column
          prop="iDType"
          label="证件类型">
          <template slot-scope="scope">
            <div>
              {{ scope.row.iDType == 'IDC01' ? '中国大陆居民身份证' : scope.row.iDType == 'IDC02' ? '护照' :scope.row.iDType == 'IDC03' ? '港澳台居民居住证' : '台胞证'}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="iDNumber"
          label="证件号">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱">
        </el-table-column>
        <el-table-column
          prop="department"
          label="部门">
        </el-table-column>
        <el-table-column
          prop="jobTitle"
          label="职务">
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
                <el-button @click="delClick(scope.row,scope.$index)" type="text" size="small">删除</el-button>
            </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="titles">
        <div class="titleNo titleLeft">订单信息</div>
    </div>
    <div class="numbers">
        <div>开通订单数 (999条/单)</div>
        <div>
            <input type="number" v-model="tableData.length" disabled style="width: 80px;">
            <span>每人默认对应一条订单，如需增加订单条数请联系工作人员:010-84556507</span>
        </div>
        <Button style="width:90px;" type="primary" @click="successSubmit()">确定提交</Button>
    </div>


    <iModal
      title="添加联系人"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
          >
            <FormItem label="联系人" :required="true" prop="name">
              <Select v-model="formInline.name" style="width:400px;">
                <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>

            <div class="addPeople" @click="addPeople">添加新联系人</div>

            <FormItem label="手机号" prop="phoneNumber">
                <Input
                    style="width:400px;"
                    type="tel"
                    placeholder="请输入手机号"
                    disabled
                    v-model="formInline.phoneNumber"
                />
                <span v-if="formInline.phoneNumber" class="pointer">修改</span>
            </FormItem>
            
            <FormItem label="证件类别" :required="true" prop="iDType"> 
              <Select v-model="formInline.iDType" style="width:400px;">
                <!-- <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option> -->
                
              <Option label="中国大陆居民身份证"
                         value="IDC01" />
              <Option label="护照"
                         value="IDC02" />
              <Option label="港澳台居民居住证"
                         value="IDC03" />
              <Option label="台胞证"
                         value="IDC04" />
              </Select>
            </FormItem>

            <FormItem label="证件号" prop="iDNumber">
                <Input
                    style="width:400px;"
                    type="text"
                    placeholder="请输入证件号"
                    v-model="formInline.iDNumber"
                />
            </FormItem>

            <FormItem label="邮箱" prop="email"> 
                <Input
                    style="width:400px;"
                    type="email"
                    disabled
                    placeholder="请输入你的邮箱"
                    v-model="formInline.email"
                />
            </FormItem>

            <FormItem label="部门" prop="department">
                <Input
                    style="width:400px;"
                    type="text"
                    placeholder="请输入你的部门"
                    v-model="formInline.department"
                />
            </FormItem>
            <FormItem label="职务" prop="jobTitle">
                <Input
                    style="width:400px;"
                    type="text"
                    disabled
                    placeholder="请输入你的部门"
                    v-model="formInline.jobTitle"
                />
            </FormItem>
          </Form>
        </div>
      </div>
      
      <div slot="footer">
        <Button style="width:90px;" @click="cancel">取消</Button>
        <Button style="width:90px;" type="primary" @click="handleSubmit('formInline')">确定</Button>
      </div>
    </iModal>
    <iModal
      title="添加联系人"
      v-model="showModalNew"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInlineNew"
            :model="formInlineNew"
            :rules="ruleInlineNew"
            label-position="right"
            :label-width="100"
          >

          <FormItem label="姓名" prop="name">
                <Input
                    style="width:400px;"
                    type="text"
                    placeholder="请输入姓名"
                    v-model="formInlineNew.name"
                />
            </FormItem>
            <FormItem label="手机号" prop="phoneNumber">
                <Input
                    style="width:400px;"
                    type="tel"
                    placeholder="请输入手机号"
                    v-model="formInlineNew.phoneNumber"
                />
            </FormItem>
            
            <FormItem label="证件类别" :required="true" prop="iDType"> 
              <Select v-model="formInlineNew.iDType" style="width:400px;" @change="changeCardType">
                <!-- <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option> -->
                
              <Option label="中国大陆居民身份证"
                         value="IDC01" />
              <Option label="护照"
                         value="IDC02" />
              <Option label="港澳台居民居住证"
                         value="IDC03" />
              <Option label="台胞证"
                         value="IDC04" />
              </Select>
            </FormItem>

            <FormItem label="证件号" prop="iDNumber">
                <Input
                    style="width:400px;"
                    type="text"
                    placeholder="请输入证件号"
                    v-model="formInlineNew.iDNumber"
                />
            </FormItem>

            <FormItem label="邮箱" prop="email"> 
                <Input
                    style="width:400px;"
                    type="email"
                    placeholder="请输入你的邮箱"
                    v-model="formInlineNew.email"
                />
            </FormItem>

            <FormItem label="部门" prop="department">
                <Input
                    style="width:400px;"
                    type="text"
                    placeholder="请输入你的部门"
                    v-model="formInlineNew.department"
                />
            </FormItem>
            <FormItem label="职务" prop="jobTitle">
                <Input
                    style="width:400px;"
                    type="text"
                    placeholder="请输入你的部门"
                    v-model="formInlineNew.jobTitle"
                />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button style="width:90px;" @click="cancel">取消</Button>
        <Button style="width:90px;" type="primary" @click="handleSubmitNew('formInlineNew')">确定</Button>
      </div>
    </iModal>
    <addManModel
      :show="modelShow"
      :modelTitle="modelTitle"
      :options="options"
      @close="modelShow = false"
      @addFinsh="addFinsh"
    ></addManModel>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import addManModel from "../../set/company-info/subpages/company-info-linkman/add-operate.vue";
export default {
    name: 'scanCreat',
    components: {
        addManModel
    },
    data() {
        return {
            typeList: [{value: '11',label: '111'},{value: '22',label: '222'}],
            numberAll: 8,
            showModal: false,
            showModalNew: false,
            formInline: {
            },
            ruleInline: {
                name: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                phoneNumber: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
                iDType: [{ required: true, message: '证件类别为空', trigger: 'change' }],
                iDNumber: [{ required: true, message: '证件号不能为空', trigger: 'blur' }],
                email: [{ required: true, message: '邮箱不能为空', trigger: 'blur' }],
                department: [{ required: true, message: '部门不能为空', trigger: 'blur' }],
                jobTitle: [{ required: true, message: '职务不能为空', trigger: 'blur' }],
            },
            formInlineNew: {
                name: '',
                phoneNumber: ''
                
            },
            ruleInlineNew: {
                name: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                phoneNumber: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
                iDType: [{ required: true, message: '证件类别为空', trigger: 'change' }],
                iDNumber: [{ required: true, message: '证件号不能为空', trigger: 'blur' }],
                email: [{ required: true, message: '邮箱不能为空', trigger: 'blur' }],
                department: [{ required: true, message: '部门不能为空', trigger: 'blur' }],
                jobTitle: [{ required: true, message: '职务不能为空', trigger: 'blur' }],
            },
            info: {
                name: '111',
                card: '111',
                phone: '111',
                email: '111',
            },
            typePeople: 1,
            tableData: [],
            hostData: [], 
            ChangeMainByContactIdDto: '', // 主选择
            ChangeMainByDto: [],  // 次新
            InsertWithContactId: [], // 次选择
            CreateDtos: [],  // 次选择
            DeleteDtos: [],
            secondData: [],
            addDate: [],
            deleteDate: [],
            addHostDate: [],
            modelShow: false,
            modelTitle: "编辑联系人",
            options: {
                msg: '',
                model: "edit",
                status: 1
            }
        }
    },
    computed: {
      ...mapGetters({
        company: "loginModule/getCompany",
        joinInfo: "loginModule/getJoinInfo",
        exhibition: "loginModule/getExhibition",
      }),
      header() {
        return this.$store.state.header;
      }
    },
    methods: {
        addPhone(){},
        async handleSubmit(name) {
          let form = this.formInline;
          let valid = await this.validForm(name);
          if (!valid) return;
          this.loading = true;
          let body = {
            "ExhibitonId":this.exhibitonId.id,
            "JoinId":this.joinInfo.joinId,
            "CommandId":1,  // "1：新增，2：修改，3：删除",
            "LinkType": '',
            "Address": '',
            "CompId": this.company.id,
            "name":"SuJunChen3",
            "phoneNumber":"17768495505",
            "iDType":"ID01",
            "iDNumber":"320928199811096634",
            "email":"1415752253@qq.com",
            "department":"部门",
            "jobTitle":"工作",
            "isMain": this.typePeople == 1 ? true : false
          }
          this.tableData.push(body)
          
        },
        async handleSubmitNew(name) {
          let form = this.formInlineNew;
          let valid = await this.validForm(name);
          if (!valid) return;
          this.loading = true;
          let body = {
            "ExhibitonId":this.exhibition.id,
            "JoinId":this.joinInfo.joinId,
            "CommandId":1,  // "1：新增，2：修改，3：删除",
            "LinkType": '',
            "Address": '',
            "CompId": this.company.id,
            "name":form.name,
            "phoneNumber":form.phoneNumber,
            "iDType":form.iDType,
            "iDNumber":form.iDNumber,
            "email":form.email,
            "department":form.department,
            "jobTitle":form.jobTitle,
            "isMain":this.typePeople == 1 ? true : false
          }
          console.log(body)
          
          if (this.typePeople == 1) {
              this.hostData = []
              this.addHostDate = []
              this.hostData.push(body) 
              this.addHostDate.push(body)
            } else {
              this.secondData.push(body)
              this.addDate.push(body)
            }
            this.showModal = false
            this.showModalNew = false
            this.tableData.push(body)
        },
        validForm(name) {
        // 验证表单
          return new Promise((resolve, reject) => {
              this.$refs[name].validate(valid => {
                resolve(valid);
              });
          });
        },
                //   删除
        delClick(row,index){
            if(row.id){
                this.deleteDate.push(row)
            }
            this.secondData.splice(index, 1);
          },
        addPeople(){
            this.showModal = false
            this.showModalNew = true
        },
        addFinsh(){},
        hostPeople(){
            this.showModal = true
            this.showModalNew = false
            this.typePeople = 1
        },
        secondPeople(){
            this.showModal = true
            this.showModalNew = false
            this.typePeople = 2
            console.log(this.deleteDate,11)
            console.log(this.secondData,22)
        },
        cancel(){
            this.showModal = false
            this.showModalNew = false
        },
        changeCardType () {
            this.formInlineNew.iDNumber=''
        }
    }
}
</script>

<style lang="scss" scoped>
::deep .el-table__header-wrapper{
    background-color: #999;
}
.p30{
    padding: 30px;
}
.titles{
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8eaec;
    .title:before {
        content: '*';
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 14px;
        color: #ed4014;
        
    }
    .titleLeft{
        padding-left: 20px;
        font-size: 14px;
        line-height: 50px;
    }
    .titleRight{
        padding-right: 20px;
        font-size: 14px;
        line-height: 50px;
        color: #ed4014;
    }
    .titleNo{
        padding-left: 30px;
    }
}

.addPro {
    margin: 30px;
    height: 200px;
    width: 300px;
    padding-top: 30px;
    background-color: #fafafa;
    .icon {
      font-size: 60px;
      text-align: center;
      display: block;
      color: #999;
    }
    span {
      display: block;
      font-size: 18px;
      color: #999;
      text-align: center;
      position: relative;
      top: -5px;
    }
  }
  .proText{
    padding: 30px 0 30px 30px !important;
    p{
        line-height: 30px;
        
    }
    
  }
  .addPeople{
        margin-left: 100px;
        color: #ed4014;
        margin-bottom: 24px;
    }
    span{
        color: #ed4014;
        margin-left: 10px;
    }
    .numbers{
        margin: 30px;
        input{
            margin: 30px 0;
        }
        span{
            color: #999;
        }
    }
    .pointer{
        cursor: pointer;
    }
</style>